/**
 * UTF-8 안전 Base64 디코딩
 * atob()은 UTF-8 문자(한글 등)를 제대로 처리하지 못함
 * 이 함수는 TextDecoder를 사용하여 UTF-8 문자열을 올바르게 디코딩
 */
export function decodeBase64UTF8(base64: string): string {
  const binaryString = atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return new TextDecoder('utf-8').decode(bytes)
}

/**
 * JWT 또는 Base64 토큰을 파싱
 * - JWT 형식 (xxx.yyy.zzz): payload 부분만 디코딩
 * - Base64 형식: 전체 디코딩 (레거시 호환)
 */
export function parseAuthToken<T = any>(token: string): T | null {
  try {
    const parts = token.split('.')
    if (parts.length === 3) {
      // JWT 형식: payload(두 번째 부분) 디코딩
      return JSON.parse(decodeBase64UTF8(parts[1]))
    }
    // 레거시 Base64 형식
    return JSON.parse(decodeBase64UTF8(token))
  } catch (error) {
    console.error('토큰 파싱 실패:', error)
    return null
  }
}

/**
 * 토큰에서 사용자 식별 정보 추출
 * kakao_id 또는 naver_id를 반환
 */
export function getProviderIdFromToken(token: string): { providerId: string; type: 'kakao' | 'naver' } | null {
  const decoded = parseAuthToken(token)
  if (!decoded) return null

  if (decoded.kakao_id) {
    return { providerId: decoded.kakao_id, type: 'kakao' }
  }
  if (decoded.naver_id) {
    return { providerId: decoded.naver_id, type: 'naver' }
  }
  return null
}
